import { render } from "./LeadCover.vue?vue&type=template&id=0191b289"
import script from "./LeadCover.vue?vue&type=script&lang=js"
export * from "./LeadCover.vue?vue&type=script&lang=js"

import "./LeadCover.vue?vue&type=style&index=0&id=0191b289&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__